<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'finance'
    }
</script>


// WEBPACK FOOTER //
// Finance.vue?005b5ee2